import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type UseTrackEditInCanvasOpenedParams } from './useTrackEditInCanvasOpened';
import META from './useTrackEditInCanvasSubmenuShown.meta';

export type EditInCanvasSubmenuOpenedFrom = Extract<
  UseTrackEditInCanvasOpenedParams['opened_from'],
  | 'action_bar'
  | 'asset_context_menu'
  | 'asset_modal_header_menu'
  | 'gallery_item_context_menu'
  | 'gallery_item_ellipsis_menu'
  | 'gallery_multi_select_context_menu'
  | 'gallery_multi_select_ellipsis_menu'
  | 'table_item_context_menu'
  | 'table_item_ellipsis_menu'
  | 'table_multi_select_context_menu'
  | 'table_multi_select_ellipsis_menu'
>;

export type UseTrackEditInCanvasSubmenuShownParams = {
  opened_from: EditInCanvasSubmenuOpenedFrom;
  clip_count: number;
  tool_actions: UseTrackEditInCanvasOpenedParams['action'][];
  size_set_eligible: boolean;
  size_set_offered: boolean;
  size_set_id?: string;
  size_set_format_count?: number;
};

export const useTrackEditInCanvasSubmenuShown = () => {
  const { track } = useAnalyticsUtilities();

  const trackEditInCanvasSubmenuShown = useCallback(
    (params: UseTrackEditInCanvasSubmenuShownParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackEditInCanvasSubmenuShown };
};
